import { CalculateInvoiceResultDto, CreateInvoiceDto, GetInvoiceDto } from "../../types/invoice.types";
const to2 = (n: number) => parseFloat(n.toFixed(2));


export const CalculateInvoice = (
  invoice: CreateInvoiceDto | GetInvoiceDto,
  roundOffChecked = false
): CalculateInvoiceResultDto => {
  let subtotal = 0;
  let total = 0;
  let taxTotal = 0;
  let sacTotal = 0;
  let totalDiscount = 0;
  let allItemTotal = 0;

  invoice.invoice_items.forEach((item) => {
    const lineTotal = item.quantity * item.unit_price;

    subtotal += lineTotal;

    // Apply percentage discount
    const discountRate = (item.discount || 0) / 100;
    const discountedLineTotal = lineTotal - lineTotal * discountRate;
    totalDiscount += (lineTotal - discountedLineTotal);

    const sacDiscountRate =
      (discountedLineTotal * Number(item.sac_gst_rate)) / 100;
    sacTotal += sacDiscountRate;

    const afterAddedSac =
      discountedLineTotal +
      (discountedLineTotal * Number(item.sac_gst_rate)) / 100;

    allItemTotal += afterAddedSac;
  });

  allItemTotal = parseFloat(allItemTotal.toFixed(2));

  if (invoice.gstRate) {
    taxTotal = (allItemTotal * (invoice.gstRate as number)) / 100;
    total = allItemTotal + taxTotal;
  } else {
    total = allItemTotal;
  }

  let roundOff = 0;

  if (roundOffChecked) {
    const up = Math.ceil(total);
    const down = Math.floor(total);

    const roundedUp = up - total;
    const roundedDown = total - down;

    roundOff = roundedUp < roundedDown ? roundedUp : -roundedDown;
    total = parseFloat((total + roundOff).toFixed(2));
  }

  total = parseFloat(total.toFixed(2));

  // Final two-decimal formatting
  total = to2(total);
  taxTotal = to2(taxTotal);
  sacTotal = to2(sacTotal);
  totalDiscount = to2(totalDiscount);
  subtotal = to2(subtotal);
  roundOff = to2(roundOff);


  return {
    total,
    taxTotal,
    sacTotal,
    totalDiscount,
    subTotal: subtotal,
    roundOff,
  };
};
